import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import { isEmpty } from 'lodash';

// FIXME: We are always send 1 type of note here, why everything here is plural
// super confusing!
export default class ACNotesDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        notes: '',
        dateTime: null,
      },
    };
    this.onChangeNotes = this.onChangeNotes.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
  }

  componentWillReceiveProps(props) {
    const { data } = this.state;
    data.notes = props.notes;
    data.dateTime = props.dateTime;
    this.setState({ data });
  }

  onChangeNotes(e) {
    const {
      target: { value },
    } = e;
    const { data } = this.state;
    data.notes = value;

    this.setState({ data });
  }

  /**
   * Note Date Changed
   */
  onNoteDateChanged = dateTime => {
    const { data } = this.state;
    data.dateTime = dateTime;
    this.setState({ data });
  };

  onClickUpdate() {
    const { data } = this.state;
    const { areNotesCompulsory, onClickUpdateFunc } = this.props;

    if (areNotesCompulsory === true && isEmpty(data.notes)) {
      alert('Please enter notes');
      return;
    }
    onClickUpdateFunc(data);
  }

  CloseDialog() {
    this.props.onClickCancelFunc();
  }

  render() {
    const { title, isMultiline, withDate = false } = this.props; //TODO: Use prop-types
    const { data } = this.state;
    const { notes, dateTime } = data;
    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="form-dialog-title"
        fullWidth
        onEscapeKeyDown={this.props.onClickCancelFunc}
      >
        <DialogTitle id="form-dialog-title">
          <strong>{title}</strong>
        </DialogTitle>
        <DialogContent>
          {withDate && (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant="dialog"
                format="MMMM dd, yyyy"
                margin="normal"
                label="Note Date"
                value={dateTime}
                onChange={this.onNoteDateChanged}
              />
            </MuiPickersUtilsProvider>
          )}
          <TextField
            autoFocus
            margin="dense"
            id="notes"
            label="Notes"
            type="text"
            fullWidth
            onChange={this.onChangeNotes}
            multiline={isMultiline}
            rows="4"
            value={notes}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClickCancelFunc} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={this.onClickUpdate}
            variant="contained"
            color="primary"
            style={{
              color: 'white',
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
